import { Collapse, Grid2, Typography } from "@mui/material";
import React, { Fragment } from "react";
import {
  CommonGrid2,
  StyledFlexColumnView,
  SubTitleTypo,
  TitleTypo,
} from "../../../common-components/StyledComponents";
import { Gauge, gaugeClasses } from "@mui/x-charts";
import CommonButton from "../../../../component/Button";
import { CommonTippy, CustomAvatar, CustomizeSpan } from "../../../jobs/style";
import ExclamatoryIco from "../../../../assets/icons/ExclamatoryIco";
import RecommendationIco from "../../../../assets/icons/RecommendationIco";

export default function CandidateResume({
  gridData,
  reviewGridData,
  scoringResult,
  handleViewRecord,
  handleDetails,
}) {
  return (
    <Fragment>
      <Typography variant="h2" fontWeight={600}>
        {"Scoring Results"}
      </Typography>
      {scoringResult.map((_, index) => {
        if (_.data === undefined || _.data?.length === 0) return null;
        return (
          <CommonGrid2 key={index} container spacing={2} marginTop={"1.5rem"}>
            <Typography variant="span" color="#8396A8">
              {_?.title}
            </Typography>

            {_.data?.length !== 0 &&
              _.data.map((innerItem, innerIndex) => {

                // ── ERROR OCCURED CARD ──
                if (_.name === "error_occured") {
                  return (
                    <CommonGrid2
                      key={innerIndex}
                      size={12}
                      border={"1px solid #FDA29B"}
                      padding={"1rem 12px"}
                      borderRadius={"10px"}
                      background={"#FEF3F2"}
                      display={"flex"}
                      alignItems={"flex-start"}
                      gap={"12px"}
                    >
                      {/* Red icon circle */}
                      <CommonGrid2
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"center"}
                        width={"44px"}
                        height={"44px"}
                        minWidth={"44px"}
                        borderRadius={"50%"}
                        background={"#FEE4E2"}
                      >
                        <Typography
                          fontSize={"18px"}
                          color={"#B42318"}
                          lineHeight={1}
                        >
                          ✕
                        </Typography>
                      </CommonGrid2>

                      {/* File name + error message */}
                      <CommonGrid2 flex={1}>
                        <CommonGrid2
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"space-between"}
                          gap={"8px"}
                          flexWrap={"wrap"}
                        >
                          <Typography
                            fontWeight={600}
                            fontSize={"15px"}
                            color={"#7A271A"}
                          >
                            {innerItem?.resume_file_name}
                          </Typography>
                          <Typography
                            fontSize={"12px"}
                            fontWeight={600}
                            sx={{
                              background: "#FEE4E2",
                              color: "#B42318",
                              border: "1px solid #FDA29B",
                              borderRadius: "6px",
                              padding: "2px 10px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Failed
                          </Typography>
                        </CommonGrid2>
                        <Typography
                          fontSize={"13px"}
                          color={"#B42318"}
                          marginTop={"6px"}
                          lineHeight={1.5}
                        >
                          {innerItem?.error_message}
                        </Typography>
                      </CommonGrid2>
                    </CommonGrid2>
                  );
                }
                // ── END ERROR OCCURED CARD ──

                // ── SUCCESS / NEEDS REVIEW CARD ──
                return (
                <CommonGrid2
                  key={innerIndex}
                  border={"1px solid #EAECF0"}
                  padding={"1rem 12px"}
                  size={12}
                  borderRadius={"10px"}
                  container
                  spacing={2}
                >
                  <CommonGrid2 width={"80px"}>
                    <Gauge                        width={90}
                      height={90}
                      value={innerItem?.resume_score?.[0]?.score}
                      valueMax={100}
                      cornerRadius="50%"
                      text={({ value, valueMax }) =>
                        `${innerItem?.resume_score?.[0]?.score}%`
                      }
                      sx={(theme) => ({
                        [`& .${gaugeClasses.valueText}`]: {
                          fontSize: 13,
                          color: "#101828",
                          fontWeight: 600,
                        },
                        [`& .${gaugeClasses.valueArc}`]: {
                          fill: "green",
                        },
                      })}
                    />
                  </CommonGrid2>
                  <CommonGrid2 width={"calc(100% - 96px)"}>
                    <CommonGrid2
                      container
                      spacing={2}
                      justifyContent={"space-between"}
                    >
                        <CommonGrid2>
                          <Typography variant="h5">
                            {innerItem?.personal_details?.candidate_name}
                          </Typography>
                          <Typography
                            variant="h5"
                            color="#8396A8"
                            marginTop={"5px"}
                            fontWeight={500}
                          >
                            {innerItem?.personal_details?.title}
                          </Typography>
                        </CommonGrid2>
                        {_.record && (
                          <CommonGrid2>
                            <CommonButton
                              value={_.record}
                              variant="outlined"
                              color="#344054"
                              border="#D0D5DD"
                              fontWeight="600"
                              padding={"6px 20px"}
                              onClick={() => handleViewRecord(innerItem, _)}
                            />
                          </CommonGrid2>
                        )}
                      </CommonGrid2>
                      {_.name === "need_review" ? (
                        <CommonGrid2
                          padding={"10px"}
                          background="#FFFAE3"
                          marginTop={"12px"}
                          borderRadius={"8px"}
                          display={"flex"}
                          alignItems={"center"}
                          gap={"10px"}
                        >
                          <ExclamatoryIco size="30px" />
                          <Typography>
                            <CustomizeSpan fontWeight={700}>
                              {innerItem?.personal_details?.candidate_name} -{" "}
                              {innerItem?.personal_details?.title}
                            </CustomizeSpan>{" "}
                            already exists in Candidate Hub
                          </Typography>
                        </CommonGrid2>
                      ) : (
                        <CommonGrid2
                          padding={"10px"}
                          background="#EBFFF2"
                          marginTop={"12px"}
                          borderRadius={"8px"}
                          display={"flex"}
                          alignItems={"center"}
                          gap={"10px"}
                        >
                          <RecommendationIco />
                          <Typography>Added to Candidate Hub</Typography>
                        </CommonGrid2>
                      )}
                      <Collapse
                        in={_.toggles[innerIndex] === "Hide Details"}
                        timeout="auto"
                        unmountOnExit
                      >
                        <CommonGrid2
                          display={"flex"}
                          gap={"1rem"}
                          justifyContent={"space-between"}
                          margin={"0.7rem 0px 0.3rem"}
                        >
                          {gridData(innerItem).map((item) => (
                            <Grid2
                              size={3}
                              key={item.id}
                              padding={"10px"}
                              width={"100%"}
                            >
                              <StyledFlexColumnView gap={"6px"}>
                                <CommonTippy
                                  content={item.title}
                                  placement="top"
                                  color={"#7F56D9"}
                                  fontSize="12px"
                                >
                                  <TitleTypo
                                    fontSize={"15px"}
                                    fontWeight={600}
                                    color="#5B738B"
                                    whiteSpace="nowrap"
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                  >
                                    {item.title}
                                  </TitleTypo>
                                </CommonTippy>
                                <CommonGrid2 display={"flex"} gap={"8px"}>
                                  {item?.icon && (
                                    <CustomAvatar
                                      src={item.icon}
                                      width={"22px"}
                                      height="21px"
                                      borderRadius="50%"
                                      margin="0px 0px 4px 0px"
                                    />
                                  )}
                                  <SubTitleTypo
                                    fontSize={"14px"}
                                    whiteSpace="nowrap"
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                  >
                                    {item.contentKey}
                                  </SubTitleTypo>
                                </CommonGrid2>
                              </StyledFlexColumnView>
                            </Grid2>
                          ))}
                        </CommonGrid2>
                      </Collapse>
                    </CommonGrid2>
                    <CommonGrid2
                      size={12}
                      display={"flex"}
                      justifyContent={"end"}
                      marginTop={
                        _.toggles[innerIndex] === "Hide Details" && "-2rem"
                      }
                    >
                      <CommonButton
                        value={_.toggles[innerIndex]}
                        variant="outlined"
                        color="#344054"
                        border="transparent"
                        fontWeight="600"
                        padding={"6px 20px"}
                        onClick={() => handleDetails(index, innerIndex)}
                      />
                    </CommonGrid2>
                  </CommonGrid2>
                );
              })}
          </CommonGrid2>
        );
      })}
    </Fragment>
  );
}